import React from 'react';
import { googleRating } from '../data/stats';

// Google Material palette
const G_TEXT = '#202124';
const G_SECONDARY = '#5f6368';
const G_LINK = '#1a73e8';
const G_STAR = '#fbbc04';
const G_STAR_EMPTY = '#dadce0';
export function GoogleReviews() {
  const {
    score,
    value,
    count
  } = googleRating;
  return <div role="group" aria-label={`Google-Bewertungen: ${score} von 5 Sternen aus ${count} Rezensionen`} className="inline-flex items-center gap-3.5 rounded-xl bg-white py-3 pl-3.5 pr-5 text-left" style={{
    fontFamily: "Roboto, Arial, sans-serif",
    letterSpacing: 0,
    boxShadow: '0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)'
  }} data-id="element-248" data-mp="2gofn2mu810ov">
      <GoogleLogo className="h-9 w-9 shrink-0" data-id="element-249" data-mp="2zd43owlo8juu" />
      <div aria-hidden="true" data-id="element-250" data-mp="1sxtqbrpo32u6">
        <p className="leading-none" style={{
        color: G_SECONDARY,
        fontSize: 13
      }} data-id="element-251" data-mp="1sy3gpgemjc0e">
          Google Bewertungen
        </p>
        <div className="mt-1.5 flex items-center gap-1.5" data-id="element-252" data-mp="1nxxitihrgt9v">
          <span className="leading-none" style={{
          color: G_TEXT,
          fontSize: 22,
          fontWeight: 500
        }} data-id="element-253" data-mp="2taugqq4uthug">
            {score}
          </span>
          <Stars value={value} data-id="element-254" data-mp="2y8e5wl33bf16" />
          <span className="leading-none" style={{
          color: G_LINK,
          fontSize: 13
        }} data-id="element-255" data-mp="2y7bdu9u176jo">
            ({count})
          </span>
        </div>
      </div>
    </div>;
}
export function Stars({
  value
}: {
  value: number;
}) {
  return <span className="flex items-center" data-id="element-256" data-mp="2akcxdc5wvylr">
      {Array.from({
      length: 5
    }).map((_, i) => {
      const fill = Math.max(0, Math.min(1, value - i));
      return <span key={i} className="relative h-[17px] w-[17px]" data-id="element-257" data-mp="2fcwa66wryppi" data-mpi={i}>
            <StarShape color={G_STAR_EMPTY} data-id="element-258" data-mp="21kpvkp99sqs6" />
            <span className="absolute inset-0 overflow-hidden" style={{
          width: `${fill * 100}%`
        }} data-id="element-259" data-mp="25l0346cpnp95">
              <StarShape color={G_STAR} data-id="element-260" data-mp="1rl8ruddkwmyu" />
            </span>
          </span>;
    })}
    </span>;
}
function StarShape({
  color
}: {
  color: string;
}) {
  return <svg viewBox="0 0 24 24" className="absolute left-0 top-0 h-[17px] w-[17px]" aria-hidden="true" data-id="element-261" data-mp="1wjk6d1etjlne">
      <path fill={color} d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-262" data-mp="267vq6bkshfy" />
    </svg>;
}
export function GoogleLogo({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 48 48" className={className} aria-hidden="true" data-id="element-263" data-mp="3ki30vu7xcnox">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" data-id="element-264" data-mp="3kjxlf7faadsh" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" data-id="element-265" data-mp="h1vz5t92l0is" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" data-id="element-266" data-mp="7252pm0y8bg2" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" data-id="element-267" data-mp="2rt5tim594bay" />
    </svg>;
}